import React from 'react';
import cn from 'clsx';

import styles from './pitpass-logo.scss';

interface PitpassLogoProps {
  className?: string;
  isPitPassLogoOnly?: boolean;
}

function PitpassLogo(props: PitpassLogoProps): React.ReactElement {
  const { className, isPitPassLogoOnly = false } = props;

  return (
    <img
      alt="Pit Pass"
      className={cn(styles['logo'], className)}
      src={`https://discounttire.scene7.com/is/content/discounttire/logos/DT_Pit-Pass_Logo-stand-alone${
        isPitPassLogoOnly ? '-original' : ''
      }.svg`}
    />
  );
}

export default PitpassLogo;
